<script lang="ts" module>
  import CTAButton, { type CTAButtonProps } from '@/ui/elements/buttons/CTAButton.svelte';

  export type AICardHeaderActionButtonProps = Pick<
    CTAButtonProps,
    'onclick' | 'icon' | 'variant' | 'disabled' | 'loading' | 'label'
  >;
</script>

<script lang="ts">
  let { disabled, icon, label, loading, onclick, variant }: AICardHeaderActionButtonProps =
    $props();
</script>

<CTAButton {onclick} class="min-w-20" {icon} {variant} {disabled} {loading}>{label}</CTAButton>
